"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Td;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react2 = require("@chakra-ui/react");

var _Context = require("./Context");

var _jsxRuntime = require("react/jsx-runtime");

// deps
// contexts
function Td(props) {
  const {
    _columnIndex,
    children,
    ...otherProps
  } = props;
  const {
    columns,
    layout
  } = (0, _Context.useTable)();
  const color = (0, _react2.useColorModeValue)("gray.700", "white");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react2.Td, { ...otherProps,
    ...("column" === layout && {
      display: "block",
      px: "0.75rem",
      py: "0.5rem"
    }),
    children: ["column" === layout && columns && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Box, {
      fontWeight: "bold",
      fontSize: "0.75rem",
      color: color,
      textTransform: "uppercase",
      mb: "0.5rem",
      children: columns[_columnIndex]
    }), children]
  });
}

Td.propTypes = {
  _columnIndex: _propTypes.default.number,
  children: _propTypes.default.node
};